<template>
    <div class="multimedia">
        <post-back :title="tr.multimedia" />
        <div class="container">
            <br />
            <div class="text-center">
                <div class="btn-group text-center">
                    <btn :label="tr.video" :type="mode==='video'?'primary':'default'" @press="setMode('video')" size='large' />
                    <btn :label="tr.photo" :type="mode==='photo'?'primary':'default'" @press="setMode('photo')" size='large' />
                </div>
            </div>
            <br />
            <div v-if="mode==='video'">
                <template v-for="(year, idx1) in years">
                    <h2 class='text-center' :key="year+'-x'+idx1">{{year}}</h2>
                    <div class="row" :key="year+'-'+idx1">
                        <div class="col-sm-6 col-md-4 col-lg-3 video" :key="idx2" v-for="(video, idx2) in videos.filter(v=>v.date.year === year)">
                            <div class="number" style='font-size:16px;text-align:right'>{{video.date | date('D')}}</div>
                            <i-video :value="video" />
                            <b style='font-size:18px;'>{{video.title}}</b>
                        </div>
                    </div>
                </template>
            </div>
            <div class="row" v-if="mode==='photo'">
                <div class="col-xs-6 col-sm-4 col-md-3 album" :key="idx3" v-for="(album, idx3) in photoAlbums" @click="openAlbum(album)">
                    <div class="thumb">
                        <div class="photo" :key="idx4" v-for="(thumb, idx4) in album.photos.slice(0,4)" :style="{backgroundImage:`url(${thumb.src}?w=240)`}">
                            <img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
                        </div>
                    </div>
                    <div class="title">{{album.title}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime } from "luxon";
export default {
    name: 'multimedia',
    mounted() {
        let { mode } = this.$route.query;
        if (!mode) mode = 'video';
        if (mode === "video") this.mode = "video";
        if (mode === "photo") this.mode = "photo";
        location.hash = "#/multimedia?mode=" + mode;
    },
    computed: {
        seo() { return { title: this.trRaw.multimedia, description: this.trRaw.multimedia_meta_description } },
        videos() {
            let { lang } = this;
            return this.$store.state.videos.list.filter((v) => {
                if (!v.lang || v.lang == lang) return true;
                else return false;
            }).map((v) => {
                v.date = DateTime.fromISO(v.date);
                return v;
            });
        },
        photoAlbums() { return this.$store.state.albums.list; },
        years() {
            let { videos } = this;
            let years = videos.reduce((ns, v) => {
                if (ns.indexOf(v.date.year) === -1) {
                    ns.push(v.date.year);
                }
                return ns;
            }, []);
            return years;
        }
    },
    methods: {
        setMode(mode) {
            this.mode = mode;
            //console.log()
            location.hash = "#/multimedia?mode=" + mode;
        },
        openAlbum(album) {
            location.href = '#/photo-album/' + album._id;
        }
    },
    data() {
        return {
            mode: "video"
        }
    }
}
</script>
<style lang="css" scoped>
.multimedia.containers {
    padding: 6px;
}

.row {}

.video {
    margin-bottom: 18px;
}

.album .thumb {}

.album .title {
    text-align: center;
    margin-top: 8px;
}

.album {
    margin-bottom: 10px;
    cursor: pointer;
}

.thumb .photo {
    background-size: cover;
    background-position: center;
    width: 50%;
    display: inline-block;
    transition: 0.2s all ease;
}

.thumb .photo:hover {
    transform: scale(1.04);
}
</style>